import { ApolloClient, createHttpLink, InMemoryCache, from, split } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { createUploadLink } from 'apollo-upload-client'
import * as Sentry from '@sentry/browser'
import { getMainDefinition } from '@apollo/client/utilities'
import { createConsumer } from '@rails/actioncable'
import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink'

const uploadLink = createUploadLink({ uri: `/graphql`, credentials: 'include' })

const httpLink = createHttpLink({ uri: '/open_graphql' })

const errorLink = onError(({ graphQLErrors, operation }) => {
  for (let i = 0; i < graphQLErrors?.length; i++) {
    const { message, path } = graphQLErrors[i]
    Sentry.setContext(`graphql errors[${i}]`, { message, path })
  }

  Sentry.setContext('operation', {
    operationName: operation.operationName,
    variables: operation.variables,
  })
})

const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
const host = window.location.hostname
const port = window.location.port ? `:${window.location.port}` : ''

const cableURL = `${protocol}//${host}${port}/cable`

const cable = createConsumer(cableURL)
const actionCableLink = new ActionCableLink({ cable })

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  actionCableLink,
  uploadLink
)

const client = new ApolloClient({
  link: from([errorLink, splitLink]),
  cache: new InMemoryCache(),
})

const openClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache(),
})

export default client
export { openClient }
